var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('aside',{staticClass:"modal"},[_c('div',{staticClass:"modal_container"},[_c('img',{staticClass:"modal_close-button",attrs:{"src":require("@/assets/icons/ic-close.svg")},on:{"click":_vm.closeModal}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }